import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DialogService,
    IHD_DIALOG_SCROLL_STRATEGY_PROVIDER,
} from './dialog.service';
import { DialogLoaderComponent } from './loader/dialog-loader.component';
import { DialogContainerComponent } from './dialog-container.component';
import { DialogConfirmComponent } from './confirm/dialog-confirm.component';
import { DialogDateComponent } from './date/dialog-date.component';
import { DialogAlertComponent } from './alert/dialog-alert.component';
import { DialogSaveChangesComponent } from './save-changes/dialog-save-changes.component';
import { DialogAttachmentComponent } from './attachment/dialog-attachment.component';

import { TranslateModule } from '@ngx-translate/core';
import { DateInputModule } from '../date-input/date-input.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormValidationModule } from '../form-validation/form-validation.module';
import { ElementsModule } from '@shared/elements/elements.module';
import { DialogTitleComponent } from './dialog-title.component';
import { DialogBodyComponent } from './dialog-body.component';
import { DialogActionsComponent } from './dialog-actions.component';
import { DialogCloseComponent } from './dialog-close.component';
import { DialogPhoneVerificationComponent } from './phone-verification/dialog-phone-verification.component';

@NgModule({
    imports: [
        CommonModule,
        ElementsModule,
        TranslateModule,
        ReactiveFormsModule,
        PortalModule,
        DateInputModule,
        OverlayModule,
        FormValidationModule,
        FormsModule,
    ],
    exports: [
        DialogLoaderComponent,
        DialogPhoneVerificationComponent,
        DialogTitleComponent,
        DialogBodyComponent,
        DialogActionsComponent,
        DialogCloseComponent
    ],
    declarations: [
        DialogLoaderComponent,
        DialogContainerComponent,
        DialogConfirmComponent,
        DialogDateComponent,
        DialogAlertComponent,
        DialogSaveChangesComponent,
        DialogAttachmentComponent,
        DialogTitleComponent,
        DialogBodyComponent,
        DialogActionsComponent,
        DialogCloseComponent,
        DialogPhoneVerificationComponent
    ],
    providers: [DialogService, IHD_DIALOG_SCROLL_STRATEGY_PROVIDER],
})
export class DialogModule {}
